<div class="mt-5">
  <div class="welcome-screen mt-2 container-sm">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div *ngIf="wrongRequestPerson && !loading" class="alert alert-info mt-2" role="alert">
          <i class="fa fa-exclamation-circle fa-2x custom-icon-info"></i>
          <b>
            {{messageErrorRequest}}
          </b>
        </div>
        <div class="alert alert-danger mt-2" role="alert"
             *ngIf="showErrorMessage">
          <i class="fa fa-exclamation-circle fa-2x custom-icon-danger text-danger"></i>
          <b>
            {{errorMessage}}
          </b>
        </div>
        <div class="card shadow-lg p-5 text-center" *ngIf="!wrongRequestPerson && !wrongRequestDocument">
          <div class="">
            <h4 class="title mb-4">{{title | translate}}</h4>
            <div>
              <label class="font-weight-bold">{{ "LABEL.FLOW" | translate }}</label> :
              {{document._more.workflowDescription}}
            </div>
            <div>
              <label class="font-weight-bold">{{ "LABEL.SUBJECT" | translate }}</label> :
              {{document.subject}}
            </div>

            <div class="dropdown">
              <a class="btn btn-light dropdown-toggle min-w-100" role="button"
                 data-toggle="dropdown" aria-expanded="false">
                <b class="text-primary">
                  <span>{{"Ver archivos adjuntos"}}</span>
                </b>
              </a>
              <div class="dropdown-menu">
                <a *ngFor="let resource1 of resourceList; let index=index"
                   class="dropdown-item  cursor-pointer min-w-130">
                  <label (click)="setUrlDoc(resource1)" class="cursor-pointer">
                    {{ resource1.fileName }}
                  </label>
                </a>
              </div>
            </div>
            <div class="form-group col-md-12 mb-2 max-height-98" *ngIf="showSuccessMessage">
              <div class="alert badge-dark alert-dismissible fade show mb-0" role="alert">
                <div [innerHTML]="errorMessage"></div>
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div class="modal-body custom-background">
              <div class="row mt-1">
                <div class="col-md-12" style="height: 500px">
                  <div class="custom-height-full mt-2" *ngIf="!reloadingPdf">
                    <ng2-pdfjs-viewer #pdfViewer
                                      [pdfSrc]="urlStream"
                                      [download]="false"
                                      [print]="false"
                                      scroll="V"
                                      [openFile]="false"
                                      [showSpinner]="true"
                                      [viewBookmark]="false"
                                      viewerId="documentVisor">
                    </ng2-pdfjs-viewer>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-2">
                <form [formGroup]="reviewForm">
                  <div class="form-row">
                    <div class="offset-sm-2 col-md-10 custom-container-right-padding pl-1">
                      <div class="custom-control custom-checkbox my-1 mr-sm-2 custom-float">
                        <input type="checkbox"
                               class="custom-control-input"
                               id="observedCheckbox"
                               formControlName="observed"
                               [attr.disabled]="reviewCompleted ? '' : null"
                               [checked]="getObservedCheckedBy(document)"
                               (change)="changeObserved($event)">
                        <label class="custom-control-label"
                               for="observedCheckbox">{{ "LABEL.OBSERVE-DOCUMENT" | translate }}</label>
                      </div>
                      <div class="custom-control custom-checkbox my-1 mr-sm-2 custom-float">
                        <input type="checkbox"
                               class="custom-control-input"
                               id="cancelCheckbox"
                               [attr.disabled]="reviewCompleted ? '' : null"
                               formControlName="cancelled"
                               [checked]="getCancelledCheckedBy(document)"
                               (change)="changeCancelled($event)">
                        <label class="custom-control-label"
                               for="cancelCheckbox">{{ "LABEL.CANCEL-DOCUMENT" | translate }}</label>
                      </div>
                      <div class="custom-control custom-checkbox my-1 mr-sm-2 custom-float"
                           *ngIf="hasUniqueAttach && !cancelChecked && !observedChecked">
                        <input type="checkbox"
                               class="custom-control-input"
                               id="attachCheckbox"
                               formControlName="attach"
                               (change)="changeAttach($event)"
                               [attr.disabled]="reviewCompleted || closeStamping ? '' : null"
                               [ngbTooltip]="reviewCompleted || closeStamping ? tipAttach : null">
                        <label class="custom-control-label"
                               for="attachCheckbox"
                               [ngbTooltip]="reviewCompleted || closeStamping ? tipAttach : null">{{ "LABEL.ATTACH-FILE" | translate }}</label>
                      </div>
                    </div>
                  </div>
                  <div class="form-row mt-3">
                    <div class="col-md-2">
                      <label for="commentInput"
                             class="font-weight-bold">{{ "LABEL.COMMENT" | translate }}</label>
                    </div>
                    <div class="col-md-10">
                                            <textarea type="text"
                                                      rows="3"
                                                      id="commentInput"
                                                      class="form-control textarea"
                                                      [attr.disabled]="reviewCompleted ? '' : null"
                                                      placeholder="{{ 'MESSAGE.ENTER-A-COMMENT' | translate }}"
                                                      formControlName="comment"
                                                      [value]="getCommentBy(document)"
                                                      (keyup)="keyupComment($event)"
                                                      [class.is-invalid]="isInvalidControl('comment')">
                                            </textarea>
                      <small *ngIf="isInvalidControl('comment')"
                             class="text-danger">
                        {{ "MESSAGE.ITS-NECESSARY-TO-ENTER-COMMENT" | translate }}
                      </small>
                    </div>
                  </div>
                  <div class="form-row mt-3" *ngIf="attachSelected" [hidden]="reviewCompleted">
                    <div class="col-md-2">
                      <label for="attachment"
                             class="font-weight-bold">{{ "LABEL.ANNEX" | translate }}</label>
                    </div>
                    <div class="col-md-6">
                      <div class="custom-file ml-0">
                        <input type="file" class="custom-file-input" accept="application/pdf"
                               id="attachment" (change)="changeStatus($event)">
                        <label class="custom-file-label"
                               for="attachment">
                          {{reviewForm.get('filename').value ? reviewForm.get('filename').value : ('MESSAGE.SELECT' | translate) }}
                        </label>
                        <small *ngIf="isInvalidControl('file')"
                               class="text-danger">
                          {{ "MESSAGE.ITS-NECESSARY-TO-SELECT-ANNEXED-FILE" | translate }}
                        </small>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="progress form-group mt-2">
                        <div class="progress-bar progress-bar-striped bg-success"
                             role="progressbar"
                             [style.width.%]="progressUpdate">
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <!--                        <div class="modal-footer">-->
            <!--                            <div class="container custom-container-padding-right">-->
            <!--                                <div class="form-row">-->
            <!--                                    <div class="col-md-3 offset-md-9">-->
            <!--                                        <div class="form-row">-->
            <!--                                            <div class="col-md-6 offset-md-3">-->
            <!--                                                <button type="button"-->
            <!--                                                        [disabled]="reviewCompleted"-->
            <!--                                                        class="btn btn-outline-success col-md-11 offset-md-7"-->
            <!--                                                        (click)="save()">-->
            <!--                                                    <i class="fa fa-eye"></i>{{!reviewCompleted ? ('BUTTON.REVIEW' | translate) : ('BUTTON.REVISED' | translate)}}-->
            <!--                                                </button>-->
            <!--                                            </div>-->
            <!--                                        </div>-->
            <!--                                    </div>-->
            <!--                                </div>-->
            <!--                            </div>-->
            <!--                        </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="text-center floating-bar">
    <button class="floating-button font-weight-bold" [disabled]="reviewCompleted" (click)="save()">
      <i class="fa fa-eye"></i>{{!reviewCompleted ? ('BUTTON.REVIEW' | translate) : ('BUTTON.REVISED' | translate)}}
    </button>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
<ng-template
  #tipAttach>{{ "MESSAGE.ATTACHMENT-FILES-IS-NOT-ALLOWED-BECAUSE-CONTAINS-AT-LEAST-ONE-DIGITAL-SIGNATURE" | translate }}
</ng-template>
